module.exports = __webpack_public_path__ + "img/logo_white.6a3bdbba.png";